import React, { useEffect, useState } from "react";
import Panel from "../../ui/Panel/Panel.jsx";
import Button from "../../ui/Button/Button.jsx";
import { getTestimonialConsents, withdrawTestimonialConsent } from "../../../services/engagementService";

/** Settings > Testimonial permission: quotes the filer allowed us to use; withdraw any time. */
export function TestimonialSettings() {
  const [rows, setRows] = useState(null);
  const [busyId, setBusyId] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    getTestimonialConsents()
      .then((r) => active && setRows(r || []))
      .catch(() => active && setRows([]));
    return () => {
      active = false;
    };
  }, []);

  if (!rows || rows.length === 0) return null;

  const withdraw = async (id) => {
    setBusyId(id);
    setError("");
    try {
      await withdrawTestimonialConsent(id);
      setRows((r) => r.filter((x) => x.feedbackId !== id));
    } catch (err) {
      setError(err.message || "We couldn't withdraw this permission. Please try again.");
    } finally {
      setBusyId(null);
    }
  };

  return (
    <Panel padded className="mb-5">
      <div className="text-[15px] font-semibold text-[var(--ink)] mb-1">Testimonial permission</div>
      <p className="text-[13px] text-[var(--muted)] mt-0 mb-3">
        You allowed us to quote these comments. Withdraw any time and we'll stop using the quote and remove it from our
        website.
      </p>
      {error && <p className="text-[13px] text-[var(--danger)]">{error}</p>}
      {rows.map((t) => (
        <div key={t.feedbackId} className="border border-[var(--line)] rounded-[10px] p-3 mb-2.5">
          <p className="text-[14px] text-[var(--ink)] m-0 mb-1">“{t.comment}”</p>
          <div className="flex justify-between items-center gap-2 flex-wrap">
            <span className="text-[12px] text-[var(--muted)]">
              — {[t.displayName, t.role, t.location].filter(Boolean).join(", ")}
            </span>
            <Button variant="ghost" className="!h-8 !px-3 !text-[12px]" disabled={busyId === t.feedbackId} onClick={() => withdraw(t.feedbackId)}>
              {busyId === t.feedbackId ? "Withdrawing…" : "Withdraw permission"}
            </Button>
          </div>
        </div>
      ))}
    </Panel>
  );
}
